import { NavLink, Outlet } from 'react-router';
import { useAuth } from '../auth/AuthContext';
import { SiteHeader } from './SiteHeader';

export function AppLayout() {
  const { session, signOut } = useAuth();
  return (
    <>
      <SiteHeader>
        {session?.isStaff ? (
          <>
            <NavLink to="/admin" end className="link-nav">
              Admin
            </NavLink>
            <NavLink to="/admin/accesos" className="link-nav">
              Accesos
            </NavLink>
          </>
        ) : null}
        <NavLink to="/campanas" className="link-nav">
          Campañas
        </NavLink>
        <NavLink to="/cuenta" className="link-nav">
          Cuenta
        </NavLink>
        <button type="button" className="link-nav nav-button" onClick={() => void signOut()}>
          Salir
        </button>
      </SiteHeader>
      <Outlet />
    </>
  );
}
